/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationPrepareOAuthResponse
 */
export interface InvitationPrepareOAuthResponse {
    /**
     * 
     * @type {boolean}
     * @memberof InvitationPrepareOAuthResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvitationPrepareOAuthResponse
     */
    message: string;
}

/**
 * Check if a given object implements the InvitationPrepareOAuthResponse interface.
 */
export function instanceOfInvitationPrepareOAuthResponse(value: object): value is InvitationPrepareOAuthResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function InvitationPrepareOAuthResponseFromJSON(json: any): InvitationPrepareOAuthResponse {
    return InvitationPrepareOAuthResponseFromJSONTyped(json, false);
}

export function InvitationPrepareOAuthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationPrepareOAuthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

  export function InvitationPrepareOAuthResponseToJSON(json: any): InvitationPrepareOAuthResponse {
      return InvitationPrepareOAuthResponseToJSONTyped(json, false);
  }

  export function InvitationPrepareOAuthResponseToJSONTyped(value?: InvitationPrepareOAuthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

